<div
(click)="onChange()"
[ngClass]="{'active': check, 'disabled': disabled, 'vertical-top': topBox}"
class="am-check-box"
>
  <img *ngIf="check" src="./assets/images/checkSimple.svg" alt="">
</div>
